import { render } from "./YoutubePlayer.vue?vue&type=template&id=35590afa&scoped=true"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"

import "./YoutubePlayer.vue?vue&type=style&index=0&id=35590afa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35590afa"]])

export default __exports__